// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"2b78f97a535fd41e2994","452":"dd09a7d35d6d7939e867","453":"74b679db80b3adfc2d86","454":"e82808845e7908247aa5","551":"eb24badcf0abf6bc9b82"}[chunkId] + ".js";
};